module.exports = __webpack_public_path__ + "img/高颂.b3325280.jpg";